import { useEffect } from 'react'

import {
  SafeTag,
  TimeLine,
  SliderSteps,
  Likert
} from '@itau-loans-www/components'
import { useProposal } from '@itau-loans-www/hooks'
import { sdkAnalytics } from '@itau-loans-www/services'
import { getProduct } from '@itau-loans-www/utils'

import './finished.scss'
import { sliderData, carouselConfig } from './sliderData'

const FormalizationFinished = () => {
  const product = getProduct()
  const proposalContext = useProposal()

  useEffect(() => {
    if (product === 'consignado') {
      sdkAnalytics.track('trackEvent', {
        event_name: 'proposal',
        parameters: {
          proposal_id: 'nao-aplicavel',
          custom_path: '/emprestimo/consignado/formalizacao/sucesso',
          monetary_value:
            proposalContext?.product?.proposal?.requestedLoanValue,
          installments: proposalContext?.product?.proposal?.installmentsNumber
        }
      })
    }

    if (product === 'fgts') {
      sdkAnalytics.track('trackEvent', {
        event_name: 'proposal',
        parameters: {
          proposal_id: 'nao-aplicavel',
          custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/sucesso',
          monetary_value: proposalContext?.product?.proposal?.requestedLoanValue
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="finished container">
      <SafeTag />
      <section className="finished__intro">
        <h1 className="finished__intro-title">
          Falta pouco! Em instantes, você irá receber um SMS para formalizar a
          sua proposta.
        </h1>
      </section>
      <SliderSteps sliderData={sliderData} carouselConfig={carouselConfig} />
      <section className="finished__timeline">
        <TimeLine
          className="finished__timeline-wrapper"
          title="confira abaixo o passo a passo da formalização"
          subtitle="acompanhe seu empréstimo"
          steps={[
            {
              title: 'Realizar simulação',
              text: 'Você fez a simulação e escolheu o valor ideal para o seu momento',
              status: 'done'
            },
            {
              title: 'confirmar dados cadastrais',
              text: 'Verifique seus dados preenchidos e certifique de que os mesmo estão corretos',
              status: 'done'
            },
            {
              title: 'Finalizar contratação',
              text: 'Estamos analisando a sua proposta',
              status: 'ongoing'
            },
            {
              title: 'Receber o dinheiro',
              text: 'Quando seu empréstimo for ativado, você vai receber o dinheiro na conta informada.',
              status: 'open'
            }
          ]}
        />
      </section>
      <Likert />
    </div>
  )
}

export default FormalizationFinished
